export const customerTypes = {
    NATURAL_PERSON: "Osoba fizyczna",
    INDIVIDUAL_ENTREPRENEUR: "Jednoosobowa działalność gospodarcza",
    LEGAL_PERSON: "Spółka / Fundacja / Instytucja ",
}